import BaseCommentIdApi from "./BaseCommentIdApi";

export default class CommentLikeApi extends BaseCommentIdApi {
	protected override getBaseUrl(params: Record<string, string>) {
		return `${super.getBaseUrl(params)}/likes`;
	}

	/**
	 * @description Count all likes on a comment
	 */
	public async count(projectId: string, postId: string, commentId: string): Promise<{ count: number }> {
		return this.getRequest<{ count: number }>(this.getBaseUrl({ projectId, postId, commentId }));
	}

	/**
	 * @description Check if the user liked a comment
	 */
	public async isLiked(projectId: string, postId: string, commentId: string): Promise<{ isLiked: boolean }> {
		return this.getRequest<{ isLiked: boolean }>(`${this.getBaseUrl({ projectId, postId, commentId })}/me`);
	}

	/**
	 * @description Like a comment
	 */
	public async like(projectId: string, postId: string, commentId: string): Promise<void> {
		return this.postRequest(`${this.getBaseUrl({ projectId, postId, commentId })}/me`);
	}

	/**
	 * @description Unlike a comment
	 */
	public async unlike(projectId: string, postId: string, commentId: string): Promise<void> {
		return this.deleteRequest(`${this.getBaseUrl({ projectId, postId, commentId })}/me`);
	}
}
